export const TypesRemocaoVolume = {
    SET_ETIQUETA: "remocaoVolume/SET_ETIQUETA",
    SET_VOLUME: "remocaoVolume/SET_VOLUME",
    SET_LOCAL_REMOCAO: "remocaoVolume/SET_LOCAL_REMOCAO",
    SET_MENSAGEM: "remocaoVolume/SET_MENSAGEM",
    SET_HABILITAR_REMOCAO: "remocaoVolume/SET_HABILITAR_REMOCAO",
    SET_HABILITAR_POSICIONAMENTO: "remocaoVolume/SET_HABILITAR_POSICIONAMENTO",
    SET_LABEL_LOCAL: "remocaoVolume/SET_LABEL_LOCAL",
    SET_LOCALIDADE: "remocaoVolume/SET_LOCALIDADE",
    SET_LOCALIDADE_PAI: "remocaoVolume/SET_LOCALIDADE_PAI",
    SET_DESCRICAO_LOCALIDADE: "remocaoVolume/SET_DESCRICAO_LOCALIDADE",
    SET_LOCALIDADE_OBJETO: "remocaoVolume/SET_LOCALIDADE_OBJETO",
    SET_LOCALIDADES: "remocaoVolume/SET_LOCALIDADES",
    RESET_REMOCAO_VOLUME: "remocaoVolume/RESET_REMOCAO_VOLUME",
}

export const INITIAL = {
    Etiqueta: '',
    Volume: '',
    Mensagem: '',
    LocalRemocao: '',
    HabilitarRemocao: false,
    HabilitarPosicionamento: false,
    EventoEmpilhadeira: 0,
    MensagemQuestionamento: '',
    NomeMetodo: '',
    LabelLocal: '',
    Localidade: 0,
    LocalidadePai: 0,
    DescricaoLocalidade: '',
    LocalidadeObjeto: {},
    Localidades: []
}

export default function remocaoVolumeReducer(state = INITIAL, action) {

    switch (action.type) {
        case TypesRemocaoVolume.SET_ETIQUETA:
            return {
                ...state,
                Etiqueta: action.payload
            }
        case TypesRemocaoVolume.SET_VOLUME:
            return {
                ...state,
                Volume: action.payload
            }
        case TypesRemocaoVolume.SET_LOCAL_REMOCAO:
            return {
                ...state,
                LocalRemocao: action.payload
            }
        case TypesRemocaoVolume.SET_MENSAGEM:
            return {
                ...state,
                Mensagem: action.payload
            }
        case TypesRemocaoVolume.SET_HABILITAR_REMOCAO:
            return {
                ...state,
                HabilitarRemocao: action.payload
            }
        case TypesRemocaoVolume.SET_HABILITAR_POSICIONAMENTO:
            return {
                ...state,
                HabilitarPosicionamento: action.payload
            }
        case TypesRemocaoVolume.SET_LABEL_LOCAL:
            return {
                ...state,
                LabelLocal: action.payload
            }
        case TypesRemocaoVolume.SET_LOCALIDADE:
            return {
                ...state,
                Localidade: action.payload
            }
        case TypesRemocaoVolume.SET_LOCALIDADE_PAI:
            return {
                ...state,
                LocalidadePai: action.payload
            }
        case TypesRemocaoVolume.SET_DESCRICAO_LOCALIDADE:
            return {
                ...state,
                DescricaoLocalidade: action.payload
            }
        case TypesRemocaoVolume.SET_LOCALIDADE_OBJETO:
            return {
                ...state,
                LocalidadeObjeto: action.payload
            }
        case TypesRemocaoVolume.SET_LOCALIDADES:
            return {
                ...state,
                Localidades: action.payload
            }
        case TypesRemocaoVolume.RESET_REMOCAO_VOLUME:
            return INITIAL;
        default:
            return state;
    }
}

export const RemocaoVolumeActions = {
    setEtiqueta,
    setVolume,
    setLocalRemocao,
    setMensagem,
    setHabilitarRemocao,
    setHabilitarPosicionamento,
    setLabelLocal,
    setLocalidade,
    setLocalidadePai,
    setDescricaoLocalidade,
    setLocalidadeObjeto,
    setLocalidades,
    resetRemocaoVolume
}

function setEtiqueta(etiqueta) {
    return {
        type: TypesRemocaoVolume.SET_ETIQUETA,
        payload: etiqueta
    }
}

function setVolume(volume) {
    return {
        type: TypesRemocaoVolume.SET_VOLUME,
        payload: volume
    }
}

function setLocalRemocao(localRemocao) {
    return {
        type: TypesRemocaoVolume.SET_LOCAL_REMOCAO,
        payload: localRemocao
    }
}

function setMensagem(mensagem) {
    return {
        type: TypesRemocaoVolume.SET_MENSAGEM,
        payload: mensagem
    }
}

function setHabilitarRemocao(habilitar) {
    return {
        type: TypesRemocaoVolume.SET_HABILITAR_REMOCAO,
        payload: habilitar
    }
}

function setHabilitarPosicionamento(habilitar) {
    return {
        type: TypesRemocaoVolume.SET_HABILITAR_POSICIONAMENTO,
        payload: habilitar
    }
}

function setLabelLocal(labelLocal) {
    return {
        type: TypesRemocaoVolume.SET_LABEL_LOCAL,
        payload: labelLocal
    }
}

function setLocalidade(localidade) {
    return {
        type: TypesRemocaoVolume.SET_LOCALIDADE,
        payload: localidade
    }
}

function setLocalidadePai(localidadePai) {
    return {
        type: TypesRemocaoVolume.SET_LOCALIDADE_PAI,
        payload: localidadePai
    }
}

function setDescricaoLocalidade(descricao) {
    return {
        type: TypesRemocaoVolume.SET_DESCRICAO_LOCALIDADE,
        payload: descricao
    }
}

function setLocalidadeObjeto(localidadeObjeto) {
    return {
        type: TypesRemocaoVolume.SET_LOCALIDADE_OBJETO,
        payload: localidadeObjeto
    }
}

function setLocalidades(localidades) {
    return {
        type: TypesRemocaoVolume.SET_LOCALIDADES,
        payload: localidades
    }
}

function resetRemocaoVolume() {
    return { type: TypesRemocaoVolume.RESET_REMOCAO_VOLUME }
}